import { type Carer, UserRole } from '@lmc/ts-common'

/** Roles that can own an incident case or its follow-up actions. */
const INCIDENT_OWNER_ROLES: ReadonlyArray<UserRole> = [
  UserRole.careHomeAdmin,
  UserRole.groupAdmin,
  UserRole.groupManager,
  UserRole.management,
  UserRole.seniorCarer
]

/**
 * Whether a team member can own an incident case or a follow-up action. A
 * user has one role across all their homes, so this needs no home.
 */
export const canOwnIncidentWork = (carer: Pick<Carer, 'role'>): boolean =>
  INCIDENT_OWNER_ROLES.includes(carer.role)
